module.exports = __webpack_public_path__ + "img/image004.e1883550.jpg";